import type { ReservationSlotSummary } from '../../domain/reservationSlots';
import type { ReservationSlotRepository } from './ports/ReservationSlotRepository';

/**
 * 月別の解放枠サマリ一覧を取得するUseCase
 *
 * @description
 * 解放枠一覧タブの表示に使用する。年月降順のサマリを返す。
 *
 * @param {ReservationSlotRepository} repository - Repository実装（DI）
 * @returns {Promise<ReservationSlotSummary[]>} サマリ配列
 */
export async function getSummaries(
  repository: ReservationSlotRepository
): Promise<ReservationSlotSummary[]> {
  return repository.findSummaries();
}
